var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.showNavbar)?[_c('Navbar'),_c('div',{staticClass:"flex main-container"},[_c('div',{attrs:{"w":"full","py":"4"}},[_c('router-view')],1)])]:[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }